import History from '../../client/History';

class ReactRouterPlugin {
  name = 'ReactRouterPlugin';

  plugContext() {
    return {
      plugActionContext: function plugActionContext(actionContext) {
        actionContext.getRouter = () => { return History.get(); };
      }
    };
  }
}

export default ReactRouterPlugin;



// WEBPACK FOOTER //
// ./src/utils/route/ReactRouterPlugin.js